// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/commesse?societaId=1&anno=2025&data_su=competenza',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"raggruppa":"commessa","commessa":null,"fonte":"movimenti","data_riferimento":"data_competenza","totali":{"ricavi":3659591.14,"costi":3361482.15,"margine":298108.99,"margine_pct":8.1,"movimenti":5161},"origini":[{"origine":"contabilita","ricavi":0,"costi":1257630.03,"margine":-1257630.03,"movimenti":230}],"fatture_non_collegate":{"ricavi":6491.86,"costi":142473.94},"data":[{"codice":"ESSELUNGA2025","etichetta":"ESSELUNGA 2025","ricavi":1647199.14,"costi":1072339.03,"margine":574860.11,"margine_pct":34.9,"movimenti":215}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/bop-go/dati-commerciali/commesse?societaId=1&anno=2025&commessa=SMARTILIO2025',
    requestBody: null,
    response: '{"success":true,"stato":"OK","data":{"raggruppa":"sottocommessa","commessa":"SMARTILIO2025","totali":{"ricavi":405413.23,"costi":64624.88,"margine":340788.35,"margine_pct":84.1,"movimenti":517},"origini":[],"fatture_non_collegate":null,"data":[{"codice":"1","etichetta":"SMARTILIO 2025","ricavi":405413.23,"costi":64624.88,"margine":340788.35,"margine_pct":84.1,"movimenti":517}]}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
